module.exports = require("@web3auth/torus-evm-adapter");